class CustomBadges extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    console.log('CustomBadges connected');
    this.render();
  }

  static get observedAttributes() {
    return ['data-tags'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-tags' && oldValue !== newValue) {
      this.render();
    }
  }

  render() {
    const tags = this.getAttribute('data-tags')?.split(';') || [];
    const tagBadges = window.tagBadges || {};

    // Create styles

    // Create badge container
    const container = document.createElement('div');
    container.className = 'badge-container';

    // Process tags and create badges
    Object.entries(tagBadges).forEach(([key, tagData]) => {
      const tagText = tagData.text.toLowerCase();
      if (tags.some(tag => tag.toLowerCase() === tagText)) {
        const tagBadge = document.createElement('div');
        tagBadge.className = `product-tag-badge ${key}-badge`;

        if (tagData.image) {
          const tagImage = document.createElement('img');
          tagImage.src = tagData.image;
          tagImage.alt = tagData.text;
          tagImage.loading = 'lazy';
          tagImage.width = 100;
          tagBadge.appendChild(tagImage);
        } else {
          tagBadge.textContent = tagData.text;
        }

        container.appendChild(tagBadge);
      }
    });

    // Clear and update shadow DOM
    this.innerHTML = '';
    this.replaceChildren(container);
  }
}

// Register the custom element
customElements.define('custom-badges', CustomBadges);
